import {BaseFormModel} from '../base-form-model';
import {Filter} from './filter';

export class Column extends BaseFormModel<Column> {
    id: number;
    key: string;
    keyValue: string;
    accessKey: string;
    childKey: string;
    format: string;
    rowLabel: boolean;
    includeParent: boolean;
    groupingColumn: boolean;
    label: string;
    aggregation: string;
    summaryAggregation: string;
    sortOrder: number;
    includeEmpty: boolean;
    columnOne: Column;
    columnTwo: Column;
    fromTotal: boolean;
    filters: Filter[];
    filterKey: number;
    drillParent: { column: Column, value: string };
}
